/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApolloClient, gql } from 'apollo-boost';

export interface SiTeamMember {
  userId: number;
  fullName: string;
  email: string;
}

export interface BbClient {
  accountId: number;
  name: string;
  siManagers: SiTeamMember[];
}

export interface BbClientManagementResponse {
  bbClientManagement: BbClient[];
}

export interface SiTeamMembersResponse {
  siTeamMembers: SiTeamMember[];
}

export interface AssignResponse {
  assignSiManagerToClient: { success: boolean; error?: string };
}

export interface RemoveResponse {
  removeSiManagerFromClient: { success: boolean; error?: string };
}

export function getBbClientManagement(client: ApolloClient<any>) {
  return client.query<BbClientManagementResponse>({
    query: gql`
      query {
        bbClientManagement {
          accountId
          name
          siManagers {
            userId
            fullName
            email
          }
        }
      }
    `,
    fetchPolicy: 'network-only',
  });
}

export function getSiTeamMembers(client: ApolloClient<any>) {
  return client.query<SiTeamMembersResponse>({
    query: gql`
      query {
        siTeamMembers {
          userId
          fullName
          email
        }
      }
    `,
    fetchPolicy: 'network-only',
  });
}

export function assignSiManager(
  client: ApolloClient<any>,
  accountId: number,
  userId: number,
) {
  return client.mutate<AssignResponse>({
    mutation: gql`
      mutation AssignSiManager($accountId: Int!, $userId: Int!) {
        assignSiManagerToClient(accountId: $accountId, userId: $userId) {
          success
          error
        }
      }
    `,
    variables: { accountId, userId },
  });
}

export function removeSiManager(
  client: ApolloClient<any>,
  accountId: number,
  userId: number,
) {
  return client.mutate<RemoveResponse>({
    mutation: gql`
      mutation RemoveSiManager($accountId: Int!, $userId: Int!) {
        removeSiManagerFromClient(accountId: $accountId, userId: $userId) {
          success
          error
        }
      }
    `,
    variables: { accountId, userId },
  });
}
